import { createApp } from 'vue'
import { createPinia } from 'pinia'
// Self-hosted variable fonts (OFL) — drive the per-theme typography axis.
import '@fontsource-variable/inter'
import '@fontsource-variable/fraunces'
import '@fontsource-variable/jetbrains-mono'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/plus-jakarta-sans'
import '@fontsource-variable/outfit'
import '@fontsource-variable/manrope'
import '@fontsource-variable/lora'
import router from './router'
import i18n from './i18n'
import './styles/main.css'
import './styles/survey.css'
import './styles/themes.css'
import './styles/packs.css'
import App from './App.vue'
import VueApexCharts from "vue3-apexcharts";

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(VueApexCharts)

// Initialize UI Store (Language/Theme)
import { useUIStore } from './stores/ui'
import { bootTenantConfig } from './boot/tenantBoot'
const uiStore = useUIStore()
uiStore.initTheme()
uiStore.initAppearance()

import { permission } from './directives/permission'
app.directive('permission', permission)
import { scrollHint } from './directives/scrollHint'
app.directive('scroll-hint', scrollHint)

// Tenant-config-before-mount: apply the tenant's branding/appearance layer, THEN mount —
// no wrong-brand flash. Fails soft (2s timeout) so a config outage never blocks boot.
bootTenantConfig()
    .catch(() => { /* fail soft */ })
    .finally(() => {
        uiStore.initLocale()
        app.mount('#app')
    })
